import { useState } from 'react'
import { artPath } from '../art/loader'

/**
 * รูปช่องแบบภาพวาดมือ สำหรับใช้ในโมดัลและการ์ดข้อมูล
 *
 * ถอยไปใช้อีโมจิให้อัตโนมัติเมื่อไฟล์ไม่มี โดยอาศัย onError ของ <img> แทนที่จะถาม
 * ตัวโหลดว่ามีไฟล์ไหม เพราะตัวโหลดทำงานแบบอะซิงก์ ถ้าถามตอนเรนเดอร์แล้วยังโหลดไม่เสร็จ
 * จะได้คำตอบว่า "ไม่มี" ทั้งที่มี แล้ว React ก็ไม่รู้จะเรนเดอร์ซ้ำตอนไหน
 *
 * ไฟล์ถูกโหลดไปแล้วตั้งแต่ตอนเปิดกระดาน ตรงนี้จึงหยิบจากแคชเบราว์เซอร์ ไม่ได้ดาวน์โหลดซ้ำ
 */
export function TileArt({
  icon,
  emoji,
  className = 'modal-art',
  alt = '',
}: {
  icon: string
  emoji: string
  className?: string
  alt?: string
}) {
  const [failed, setFailed] = useState(false)
  const src = artPath(`icon:${icon}`)

  if (failed || !src) return <span className={`${className} is-emoji`}>{emoji}</span>

  // <picture> ให้เบราว์เซอร์เลือก webp เองถ้ารองรับ (เล็กกว่า png ราว 10 เท่า)
  // ตัวที่ไม่รองรับจะตกมาที่ <img> ซึ่งชี้ .png ต้นฉบับ และ onError ยังทำงานตามเดิม
  return (
    <picture>
      <source srcSet={src.replace(/\.png$/i, '.webp')} type="image/webp" />
      <img className={className} src={src} alt={alt} draggable={false} onError={() => setFailed(true)} />
    </picture>
  )
}
